import React, { useEffect, useState } from 'react';

import PropTypes from 'prop-types';
import _ from 'lodash';

import {
  getContentfulData,
  getData,
  contentfulFormConfig
} from '../../../contentful';

const HelpSubMenu = ({ locale }) => {
  const config = {
    ...contentfulFormConfig,
    content_type: 'header',
    locale
  };
  const [helpLink, setHelpLink] = useState({});

  useEffect(() => {
    getContentfulData(config)
      .then(res => {
        const headerData = getData(res);
        const bconLink = _.get(headerData, 'helpPdf.fields.file.url', '');
        const bussAppLink = _.get(
          headerData,
          'businessAppsHelpPdf.fields.file.url',
          ''
        );
        const iotLink = _.get(headerData, 'ioTHelpPdf.fields.file.url', '');
        setHelpLink({ bconLink, bussAppLink, iotLink });
      })
      .catch(() => {});
  }, [locale]);

  return (
    <div className="sub-menu">
      <ul className="mobile-navbar-submenu-list">
        <li className="mobile-navbar-list-item submenu-list-item">
          <a
            href="https://www.mysalesorders.com/en-US/how-to-videos"
            className="mobile-navbar-list-item-inner"
          >
            <p className="mobile-navbar-menu-item">How to videos</p>
          </a>
        </li>
        <li className="mobile-navbar-list-item submenu-list-item">
          <a
            href={_.get(helpLink, 'bconLink', '')}
            target="_blank"
            rel="noopener noreferrer"
            className="mobile-navbar-list-item-inner"
          >
            <p className="mobile-navbar-menu-item">Business Connect</p>
          </a>
        </li>
        <li className="mobile-navbar-list-item submenu-list-item">
          <a
            href={_.get(helpLink, 'bussAppLink', '')}
            target="_blank"
            rel="noopener noreferrer"
            className="mobile-navbar-list-item-inner"
          >
            <p className="mobile-navbar-menu-item">Business Apps</p>
          </a>
        </li>
        <li className="mobile-navbar-list-item submenu-list-item">
          <a
            href={_.get(helpLink, 'iotLink', '')}
            target="_blank"
            rel="noopener noreferrer"
            className="mobile-navbar-list-item-inner"
          >
            <p className="mobile-navbar-menu-item">Internet of Things</p>
          </a>
        </li>
      </ul>
    </div>
  );
};

HelpSubMenu.propTypes = {
  locale: PropTypes.string.isRequired
};

export default HelpSubMenu;
